import { RUBBERNECK_COTURN_HOST, RUBBERNECK_COTURN_PORT } from "./setting";

const config = {
  sdpSemantics: "unified-plan",
  iceServers: [
    // { urls: "stun:172.20.1.72:3478" },
    // { urls: "stun:172.20.1.148:3478" },
    // { urls: "stun:192.168.0.48:3478" },
    { urls: `stun:${RUBBERNECK_COTURN_HOST}:${RUBBERNECK_COTURN_PORT}` },
    // { urls: "stun:stun.l.google.com:19302" },
    {
      urls: `turn:${RUBBERNECK_COTURN_HOST}:${RUBBERNECK_COTURN_PORT}`,
      username: "test1",
      credential: "test123",
    },
    {
      urls: `turn:${RUBBERNECK_COTURN_HOST}:${RUBBERNECK_COTURN_PORT}?transport=tcp`,
      username: "test1",
      credential: "test123",
    },
    // { urls: "stun:stun.relay.metered.ca:80" },
    // {
    //   urls: "turn:standard.relay.metered.ca:80",
    //   username: "d635e054b6c6f05aeae5e2ec",
    //   credential: "AtVsbBNQX37F9bPs",
    // },
    // {
    //   urls: "turn:standard.relay.metered.ca:80?transport=tcp",
    //   username: "d635e054b6c6f05aeae5e2ec",
    //   credential: "AtVsbBNQX37F9bPs",
    // },
    // {
    //   urls: "turn:standard.relay.metered.ca:443",
    //   username: "d635e054b6c6f05aeae5e2ec",
    //   credential: "AtVsbBNQX37F9bPs",
    // },
    // {
    //   urls: "turns:standard.relay.metered.ca:443?transport=tcp",
    //   username: "d635e054b6c6f05aeae5e2ec",
    //   credential: "AtVsbBNQX37F9bPs",
    // },
  ],
};

export const getDefaultPeerConnectionConfig = () => {
  return config;
};
